// usado nas telas
export enum TipoMeioPagamentoPedidoTela {
    Boleto = 'BOLETO',
    Transferencia = 'TRANSFERENCIA',
    Saldo = 'SALDO'
}
